<section class="forgot-password-section container-fluid sts-section  ">


  <app-sts-section-header key="sts-thank-you-header" [errors]="errors">Thank you!</app-sts-section-header>

  <app-sts-section-body key="sts-thank-you-body">

    <!-- content -->
    <div class="sts-form wp-login-message">
      Thank you for signing up
    </div>
    <!-- content -->

  </app-sts-section-body>



  <app-sts-lower-bar>
    <a href="/Account/Signout" app-sts-cms-txt key="sts-go-back" class="sts-btn">Go Back</a>
  </app-sts-lower-bar>


</section>
